import React from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  return (
    <nav className="bg-white shadow">
      <div className="container mx-auto px-4">
        <div className="flex justify-between h-16">
          <div className="flex">
            <Link to="/" className="flex items-center text-xl font-bold">
              Allegro Scheduler
            </Link>
            <div className="ml-10 flex items-center space-x-4">
              <Link to="/" className="px-3 py-2 rounded-md hover:bg-gray-100">
                Dashboard
              </Link>
              <Link to="/campaigns" className="px-3 py-2 rounded-md hover:bg-gray-100">
                Kampanie
              </Link>
              <Link to="/settings" className="px-3 py-2 rounded-md hover:bg-gray-100">
                Ustawienia
              </Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;